import React from 'react';
import { useQueryClient } from 'react-query';

import { Button } from 'antd';
import axios from 'axios';
import styled from 'styled-components';

import { SWOT_CATEGORIES, WIDGET_TYPES } from 'common/Widgets/constants';
import { useWidgetContext } from 'common/Widgets/Widget/WidgetContext';
import { useRootContext } from 'components/layout/RootContext';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import { useAppSelector } from 'store/hook';
import { DEFAULT_SWOT_SCORES, getSwotScoresOutboundPayload } from 'utils/data/communities';
import { getCommunityById } from 'utils/helpers/communityMap';

import { useEditSwotDataModalContext } from './EditSwotDataModalContext';

const StyledButton = styled(Button)`
  width: 142px;
  border-radius: 4px;
  margin-left: 10px;
`;
const SubmitSwotScoresButton = () => {
  const queryClient = useQueryClient();
  const { communityId } = useCommunityViewContext();
  const { filters, rangeType } = useWidgetContext();
  const { showMessage } = useRootContext();
  const { stepNumber, isEditMode, temporarySwotState, competitorId, onClose } = useEditSwotDataModalContext();
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const communityName = useAppSelector((state) => state.global.selectedCommunity?.name);
  const { communityMap } = useAppSelector((state) => state.global);

  const showSaveButton = isEditMode || stepNumber === SWOT_CATEGORIES.length;

  const updateSwotScores = async () => {
    if (!competitorId || !currentUser || !communityName) {
      return;
    }

    const competitor = getCommunityById(communityMap, competitorId);

    if (!competitor) {
      showMessage('error', 'Unable to find the selected competitor.');
      return;
    }

    try {
      const existingId: number = temporarySwotState.id as number;
      const payload = {
        ...DEFAULT_SWOT_SCORES,
        ...temporarySwotState,
        ...getSwotScoresOutboundPayload({
          competitorId,
          competitorName: competitor.comunity_name,
          communityId,
          communityName,
          emailAddress: currentUser?.email,
          id: existingId,
        }),
      };

      if (isEditMode) {
        await axios.put(`/communities/${competitorId}/swot-scores`, payload);
      } else {
        await axios.post(`/communities/${competitorId}/swot-scores`, payload);
      }

      showMessage('success', 'SWOT comparison saved successfully');

      // Reset SWOT Score and SWOT Performance graphs and reload their data
      queryClient.invalidateQueries([WIDGET_TYPES.SWOT_SCORE, communityId, filters, rangeType]);
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('swot-performance'),
      });
      queryClient.invalidateQueries(['swot-categories-scores', communityId]);
      onClose();
    } catch (error) {
      console.log('error', 'Something went wrong while saving SWOT scores');
      showMessage('error', 'Failed to save SWOT comparison');
    }
  };

  return (
    <>
      {showSaveButton && (
        <StyledButton key="confirm" type="primary" onClick={updateSwotScores}>
          Save & Close
        </StyledButton>
      )}
    </>
  );
};

export default SubmitSwotScoresButton;
